import { get } from '../index';

export const getCompanyModelFileList = (companyId) => {
  return get(`/model-file/modelFileDetails/${companyId}`);
};
